<template lang="pug">
  .modal.modal-blur.fade(tabindex='-1' role='dialog' aria-hidden='true')
    .modal-dialog.modal-dialog-centered(role='document' :class="size")
      form.modal-content(@submit.prevent="$emit('save')")
        .modal-header
          h5.modal-title {{title}}
          button.close(type='button' data-dismiss='modal' aria-label='Close')
            | x
        .modal-body
          slot
        .modal-footer(v-if="!nofooter")
          button.btn.btn-secondary.mr-auto(type='button' data-dismiss='modal') Close
          loading_button.btn.btn-primary(type='submit' :loading="sending") Submit

</template>

<script>
import loading_button from '@/components/loadingBtn';
import { mapActions, mapState } from 'vuex'

export default {
  props: ['title', 'size', 'nofooter'],
  components: {
    loading_button
  },
  computed:{
    ...mapState('api', ['sending','errors']),
  }

}
</script>

<style lang="scss" scoped>
  .modal-blur{
    backdrop-filter: blur(5px);
    background: rgba(0,0,0,.5);
  }
  .modal{
    &.loading{
      &::before{
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        background: rgba(255, 255, 255, 0.4);
        backdrop-filter: blur(2px);
        z-index: 100;
      }
      &::after{
        content: '';
        width: 1.5rem;
        height: 1.5rem;
        vertical-align: text-bottom;
        border: 2px solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        animation: spinner-border .75s linear infinite;
        position: absolute;
        top:50%;
        left: 50%;
        margin-left: -.75rem;
        margin-top: -.75rem;
        color: #45aaf2!important;
        z-index: 101;
      }
      @keyframes spinner-border {
        to { transform: rotate(360deg); }
      }
    }
  }
</style>